<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Crack and Other Short Stories</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><span href="#/text/ch004#the-prototype" title="Link target outside of Sample">The Prototype</span></li>
<li id="toc-li-5"><span href="#/text/ch005#our-fathers" title="Link target outside of Sample">Our Fathers</span></li>
<li id="toc-li-6"><span href="#/text/ch006#etchings-on-a-stone-wall" title="Link target outside of Sample">Etchings on a Stone Wall</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7aa413fe